module.exports = __webpack_public_path__ + "img/cloud-4.0178df62.png";